module.exports = {"TXTWCL_You_currently_donXt_have_any_C_ELL_1":{"id":"TXTWCL_You_currently_donXt_have_any_C_ELL_1","defaultMessage":"現在ボックスはありません。"}}